import React from 'react';
export function ProblemSection() {
  return <section className="py-20 md:py-32 bg-cream-dark" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-135">
        <h2 className="text-3xl md:text-4xl font-bold text-ink mb-10 leading-tight" data-id="element-136">
          Have you noticed your belly feeling heavier lately, your clothes
          feeling tighter, even when you're eating "healthy"?
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-ink/80 leading-relaxed text-left md:text-center max-w-3xl mx-auto" data-id="element-137">
          <p data-id="element-138">
            After 40, the body changes. Even "normal" foods can trigger
            inflammation, fluid retention, and that uncomfortable belly bloat.
          </p>
          <p className="font-medium text-ink" data-id="element-139">
            It's not your fault. It's the body's natural response to certain
            irritants.
          </p>
          <p data-id="element-140">
            But what if you could reduce that bloating—without starving, without
            counting calories, and without complicated diets?
          </p>
        </div>
      </div>
    </section>;
}